import { Playground } from "docz";
import { Translator, TextHoc, TextHook } from "../../../../../docz/components";
import React from 'react';
export default {
  Playground,
  Translator,
  TextHoc,
  TextHook,
  React
};